/* =====================================================================
   Hydroh — Sticky ATC Bar (native theme port of the A/B-test injection)
   ---------------------------------------------------------------------
   MOBILE-ONLY (< 750px) sticky bottom add-to-cart bar for the Hydrogen
   Water Tablets PDP. Loaded (deferred) by snippets/hydroh-sticky-atc.liquid,
   which is only rendered on product.handle == 'hydrogen-water-tablets',
   so no path guards are needed here.

   It MIRRORS the live Kaching Bundles deal bars (reads the rendered
   widget), so every pack title / price / compare price / saving is pulled
   straight from the page and is automatically correct:
     • in every currency / market (Kaching renders localized prices), and
     • whenever the offer, prices or packs are changed in Kaching —
       the sticky bar repaints from whatever the widget shows.
   The widget's "Subscribe & Save" card is intentionally excluded — the
   sticky bar shows the one-time packs only.

   • Condensed bar = the selected pack (title + price + Save %) and a
     blue ADD button that fires the page's real Add-to-cart (so the
     selected bundle + Kaching properties are added exactly as native).
   • Tap the box  = the pack list expands UPWARD as one connected card;
     tapping a pack selects it (drives the on-page Kaching radio).

   Mobile-only is enforced twice: matchMedia below AND the CSS
   (hydroh-sticky-atc.css hides .hy-root at >= 750px). On desktop the
   theme's own .sticky-atc keeps working untouched.

   Styles live in assets/hydroh-sticky-atc.css.
   ===================================================================== */
(function () {
  "use strict";

  var NS = "hy-sticky-atc";

  /* Mobile-only gate — keep in sync with the 749px breakpoint in the CSS. */
  var MQ = window.matchMedia("(max-width: 749px)");

  /* ---- Kaching Bundles selectors (verified live on hydrohbottle) ---- */
  var SEL = {
    bars:     ".kaching-bundles__bars",
    bar:      ".kaching-bundles__bar",
    selected: "kaching-bundles__bar--selected",
    title:    ".kaching-bundles__bar-title",
    label:    ".kaching-bundles__bar-label",
    tag:      ".kaching-bundles__bar-most-popular__content",  // "Most Popular" / "Best Value"
    price:    ".kaching-bundles__bar-price",
    full:     ".kaching-bundles__bar-full-price",
    subCard:  ".kaching-bundles__subscriptions__card",
    radio:    'input[type="radio"]'
  };

  var state = { open: false, sig: "", selectedId: null };

  /* ---- helpers ----------------------------------------------------- */
  function txt(el, sel) {
    var n = sel ? el.querySelector(sel) : el;
    return n ? (n.textContent || "").replace(/\s+/g, " ").trim() : "";
  }
  function numOf(s) {
    if (!s) return null;
    var m = s.replace(/[^\d.,]/g, "").replace(/,/g, "");
    var n = parseFloat(m);
    return isNaN(n) ? null : n;
  }
  /* "Save X%+" from the gap between full (compare) and current price.
     Floored to the nearest 10% so it reads as a rounded marketing figure
     with a "+" that stays truthful because we always round DOWN.
     Percent-based, so it is correct in every currency. */
  function savingsText(price, full) {
    var pn = numOf(price), fn = numOf(full);
    if (pn == null || fn == null || fn <= pn) return "";
    var pct = Math.floor((fn - pn) / fn * 100 / 10) * 10;
    return pct >= 10 ? "Save " + pct + "%+" : "";
  }
  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return false;
    var s = window.getComputedStyle(el);
    return s.display !== "none" && s.visibility !== "hidden" && s.opacity !== "0";
  }

  /* ---- read the live kaching deal bars into a data model ----------- */
  function readBars() {
    var bars = [].slice.call(document.querySelectorAll(SEL.bar));
    return bars.map(function (bar) {
      return {
        id:    bar.getAttribute("data-deal-bar-id") || "",
        el:    bar,
        isSub: bar.className.indexOf("subscriptions") !== -1 || !!bar.querySelector(SEL.subCard),
        selected: bar.classList.contains(SEL.selected),
        title: txt(bar, SEL.title),
        tag:   txt(bar, SEL.tag),
        price: txt(bar, SEL.price),
        full:  txt(bar, SEL.full)
      };
    }).filter(function (b) {
      // one-time packs only — drop the Subscribe & Save card
      return b.id && !b.isSub && (b.title || b.price);
    });
  }

  /* Resolve which pack the sticky should show. Prefer the bar Kaching
     marks selected; while it is mid re-render fall back to our last
     known selection so the bar never flickers. */
  function resolveSelected(bars) {
    var i;
    for (i = 0; i < bars.length; i++) {
      if (bars[i].selected) { state.selectedId = bars[i].id; return bars[i]; }
    }
    if (state.selectedId) {
      for (i = 0; i < bars.length; i++) if (bars[i].id === state.selectedId) return bars[i];
    }
    state.selectedId = bars[0].id;
    return bars[0];
  }

  /* ---- native add-to-cart -----------------------------------------
     The real ATC is the product-form button which Kaching hooks to add
     the SELECTED bundle (with its properties + quantity). Exclude the
     theme's own .sticky-atc button (that bar is hidden on mobile) and
     pick the first visible, enabled one. */
  function nativeAtc() {
    var candidates = [].slice.call(document.querySelectorAll(
      '.atc-button[name="add"], .product-form__submit[name="add"], ' +
      'button[name="add"], .product-form__submit, ' +
      'form[action*="/cart/add"] [type="submit"]'
    ));
    var pool = candidates.filter(function (b) {
      return !b.disabled && !b.closest(".sticky-atc");
    });
    for (var i = 0; i < pool.length; i++) if (isVisible(pool[i])) return pool[i];
    return pool[0] || candidates[0] || null;
  }

  /* ---- select a kaching bar (drives the on-page widget) ------------ */
  function selectBar(id) {
    var bar = document.querySelector(SEL.bar + '[data-deal-bar-id="' + id + '"]');
    if (!bar) return;
    var radio = bar.querySelector(SEL.radio);
    try {
      if (radio) {
        if (!radio.checked) radio.click();
      } else {
        var label = bar.querySelector("label");
        if (label) label.click();
      }
    } catch (e) {}
  }

  /* ---- markup helpers ---------------------------------------------- */
  /* chevron caret, points up (= expand upward) */
  var CARET =
    '<span class="hy-caret" aria-hidden="true">' +
    '<svg width="14" height="8" viewBox="0 0 14 8" fill="none">' +
    '<path d="M1 7L7 1L13 7" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function lineHtml(b) {
    var save = savingsText(b.price, b.full);
    var pn = numOf(b.price), fn = numOf(b.full);
    var showFull = b.full && pn != null && fn != null && fn > pn;  // struck compare price
    return (
      '<div class="hy-line1">' +
        '<span class="hy-title">' + esc(b.title) + "</span>" +
        (b.tag ? '<span class="hy-tag">' + esc(b.tag) + "</span>" : "") +
      "</div>" +
      '<div class="hy-line2">' +
        (b.price ? '<span class="hy-price">' + esc(b.price) + "</span>" : "") +
        (showFull ? '<span class="hy-full">' + esc(b.full) + "</span>" : "") +
        (save ? '<span class="hy-save">' + esc(save) + "</span>" : "") +
      "</div>"
    );
  }

  function optionHtml(b, isSel) {
    return (
      '<button type="button" class="hy-opt' + (isSel ? " is-selected" : "") +
        '" data-hy-opt="' + esc(b.id) + '" role="radio" aria-checked="' +
        (isSel ? "true" : "false") + '">' +
        '<span class="hy-opt-text">' + lineHtml(b) + "</span>" +
      "</button>"
    );
  }

  /* ---- build the sticky root once ---------------------------------- */
  function mount() {
    if (document.querySelector("[data-" + NS + "]")) return;
    var root = document.createElement("div");
    root.className = "hy-root";
    root.setAttribute("data-" + NS, "");
    root.setAttribute("role", "region");
    root.setAttribute("aria-label", "Choose your pack and add to cart");
    root.innerHTML =
      '<div class="hy-bar">' +
        '<div class="hy-main">' +
          '<div class="hy-summary" role="button" tabindex="0" aria-expanded="false">' +
            '<span class="hy-summary-text"></span>' + CARET +
          "</div>" +
          '<div class="hy-panel" role="radiogroup" aria-label="Pack options"></div>' +
        "</div>" +
        '<button type="button" class="hy-add" data-hy-add>' +
          '<span class="hy-add-label">ADD</span>' +
          '<span class="hy-add-price"></span>' +
        "</button>" +
      "</div>";
    document.body.appendChild(root);

    /* single delegated click handler */
    root.addEventListener("click", function (e) {
      var opt = e.target.closest("[data-hy-opt]");
      if (opt) {
        var id = opt.getAttribute("data-hy-opt");
        state.selectedId = id;        // optimistic: lock our selection
        selectBar(id);                // drive the on-page Kaching widget
        setOpen(false);
        state.sig = "";               // force repaint with the new selection
        sync();
        return;
      }
      if (e.target.closest("[data-hy-add]")) {
        var btn = nativeAtc();
        if (btn) { setOpen(false); btn.click(); }
        return;
      }
      if (e.target.closest(".hy-summary")) {
        setOpen(!state.open);
      }
    });
    root.querySelector(".hy-summary").addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen(!state.open); }
    });

    /* close the expanded list on outside tap / Escape */
    document.addEventListener("click", function (e) {
      if (state.open && !e.target.closest("[data-" + NS + "]")) setOpen(false);
    }, true);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && state.open) setOpen(false);
    });

    /* show the sticky only when the on-page widget / ATC is out of view */
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; applyVisibility(); });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    applyVisibility();
  }

  /* is the on-page bundle widget or its ATC button currently visible? */
  function targetInView() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var targets = [document.querySelector(SEL.bars), nativeAtc()];
    for (var i = 0; i < targets.length; i++) {
      var el = targets[i];
      if (!el) continue;
      var r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) continue;
      if (r.top < vh && r.bottom > 0) return true;
    }
    return false;
  }

  function applyVisibility() {
    var root = document.querySelector("[data-" + NS + "]");
    if (!root) return;
    var hide = !MQ.matches || targetInView();
    if (hide && state.open) setOpen(false);
    root.classList.toggle("hy-is-visible", !hide);
  }

  function setOpen(v) {
    state.open = !!v;
    var root = document.querySelector("[data-" + NS + "]");
    if (!root) return;
    root.classList.toggle("hy-is-open", state.open);
    var s = root.querySelector(".hy-summary");
    if (s) s.setAttribute("aria-expanded", state.open ? "true" : "false");
  }

  /* ---- paint data into the root ------------------------------------ */
  function paint(bars) {
    var root = document.querySelector("[data-" + NS + "]");
    if (!root) return;
    var sel = resolveSelected(bars);

    root.querySelector(".hy-summary-text").innerHTML = lineHtml(sel);

    var addPrice = root.querySelector(".hy-add-price");
    if (addPrice) {
      addPrice.textContent = sel.price || "";
      addPrice.style.display = sel.price ? "" : "none";
    }

    root.querySelector(".hy-panel").innerHTML =
      bars.map(function (b) { return optionHtml(b, b.id === sel.id); }).join("");
  }

  /* ---- signature so we only repaint on real changes ---------------- */
  function signature(bars) {
    var sel = resolveSelected(bars);
    return sel.id + "|" + bars.map(function (b) {
      return [b.id, b.title, b.tag, b.price, b.full].join("~");
    }).join("||");
  }

  /* ---- main sync tick ---------------------------------------------- */
  function sync() {
    if (!MQ.matches) {           // mobile-only: never mount on desktop
      applyVisibility();         // hides the bar if the viewport grew past 749px
      return;
    }
    var bars = readBars();
    if (!bars.length) return;    // Kaching widget not ready yet
    mount();
    var sig = signature(bars);
    if (sig !== state.sig) {
      state.sig = sig;
      paint(bars);
    }
    applyVisibility();
  }

  /* re-evaluate when the viewport crosses the mobile breakpoint */
  if (MQ.addEventListener) MQ.addEventListener("change", function () { sync(); });
  else if (MQ.addListener) MQ.addListener(function () { sync(); });

  /* ---- boot: now + bounded retry + observer for re-renders ---------
     The retry loop + MutationObserver handle Kaching's late hydration
     and any re-render (currency switch, offer edits, variant changes) —
     the bar re-reads the widget and repaints from the fresh data. */
  function boot() {
    sync();
    var tries = 0;
    var retry = setInterval(function () {
      sync();
      if (++tries > 40) clearInterval(retry); // ~10s safety net
    }, 250);
    if (document.body) {
      new MutationObserver(function () { sync(); })
        .observe(document.documentElement, {
          childList: true, subtree: true, attributes: true, attributeFilter: ["class"]
        });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
